const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5 MB
const ALLOWED_MIME_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp']);
const ALLOWED_EXTENSIONS = new Set(['.jpg', '.jpeg', '.png', '.webp']);

export function validateImageFile(file: File | null | undefined): string | null {
  if (!file) return 'No file selected.';

  if (file.size > MAX_IMAGE_SIZE) return 'File size must be 5 MB or less.';

  if (!ALLOWED_MIME_TYPES.has(file.type)) return 'Only JPEG, PNG, and WebP images are allowed.';

  const ext = '.' + file.name.split('.').pop()?.toLowerCase();
  if (!ALLOWED_EXTENSIONS.has(ext)) return 'Only .jpg, .jpeg, .png, and .webp files are allowed.';

  return null;
}
